import {
  CallParticipantPermitsUpdate,
  CallParticipantStatesUpdate,
  CallParticipantStatusUpdate,
} from '@nauTypes/callType';
import { AnswerPreviewType, FwdPreviewType } from 'types/chatsType';
import { PollCreateResponse, PollInMessage } from 'types/pollTypes';

import { FileDescriptor } from 'types/fileTypes';
import { PostType } from 'types/postTypes';
import { RootState } from 'types/stateTypes';

export enum wsMessageTypeEnum {
  textMessage = 1,
  audioCallStarted = 2,
  videoCallStarted = 3,
  voiceMessage = 4,
  systemMessage = 5,
  callEnded = 6,
  sentContact = 7,
  poll = 9,
  callActivated = 2001,
  joinCall = 2002,
  aproveJoinCall = 2003,
  callUsers = 2004,
  participantStateChanged = 2006,
  participantPermitsChanged = 2007,
  participantStatusChanged = 2008,
  callDeclined = 6001,
  callKicked = 6002, // deprecated
  notAnswer = 6003,
  missedCall = 6004,
}

export const readableMsgTypes = [
  wsMessageTypeEnum.textMessage,
  wsMessageTypeEnum.audioCallStarted,
  wsMessageTypeEnum.videoCallStarted,
  wsMessageTypeEnum.voiceMessage,
  wsMessageTypeEnum.systemMessage,
  wsMessageTypeEnum.sentContact,
  wsMessageTypeEnum.notAnswer,
  wsMessageTypeEnum.missedCall,
];

export enum postMessageTypeEnum {
  message = 'message',
  social = 'social',
  connect = 'connect',
  disconnect = 'disconnect',
  ntf = 'ntf',
}

export enum postSocialTypeEnum {
  view = 'view',
  subStats = 'subStats',
  unsubStats = 'unsubStats',
}

export type ChangedUsersType = {
  add: string[];
  del: string[];
  rec: string[];
};

export type ActionType = {
  type: 'read' | 'update' | 'delete' | 'changeChat' | 'removeChat';
  changedUsers?: ChangedUsersType;
  image?: FileDescriptor | null; // + linkId
  users?: boolean;
  messageId?: number;
  messages?: number[];
  name?: string;
  poll?: PollInMessage;
  text?: string;
  files?: FileDescriptor[];
};

export type MessageType = {
  action?: ActionType;
  dialog: RootState['chats']['selectedChatId'];
  text: string;
};

export type FullMessageType = MessageType & {
  action: ActionType;
  ansPreview?: AnswerPreviewType;
  answered?: number;
  cType: wsMessageTypeEnum;
  createdAt?: string;
  files?: FileDescriptor[];
  forwarded?: number;
  fwdPreview?: FwdPreviewType;
  id: number;
  owner: string;
  permitsUpdate?: CallParticipantPermitsUpdate;
  poll?: PollInMessage;
  statusUpdates?: CallParticipantStatusUpdate[];
  states?: CallParticipantStatesUpdate[];
};

export type SendMessageParams = {
  messageText: string;
  uploadFiles: FileDescriptor[];
  cType?: wsMessageTypeEnum;
};

export type PostMessageType = {
  selectedChatId?: RootState['chats']['selectedChatId'];
  interlocutor?: string;
  messageText?: string;
  uploadFiles?: FileDescriptor[];
  cType?: wsMessageTypeEnum;
  dialogs?: number[]; // чаты для переадресации
  users?: string[];
  messageType?: postMessageTypeEnum;
  postuuid?: PostType['id'];
  type?: postSocialTypeEnum;
  rObjects?: string[];
  answered?: number; //  ID сообщения ответа
  ansPreview?: AnswerPreviewType;
  forwarded?: number; // ID пересылаемого сообщения
  forwardedn?: number[]; // ID's пересылаемых сообщений
  pollId?: PollCreateResponse['id'];
};

export type PostMessagePayloadType = Pick<
  PostMessageType,
  'cType' | 'users' | 'dialogs' | 'forwarded' | 'forwardedn' | 'pollId'
> & {
  answered?: number;
  dialog?: PostMessageType['selectedChatId'];
  interlocutor?: string;
  files?: PostMessageType['uploadFiles'];
  text?: PostMessageType['messageText'];
};

export type PostSocialPayloadType = {
  type: postSocialTypeEnum;
  rObjects: string[];
};

export type handleMessageProps = {
  fullMessage: FullMessageType;
  selectedChatId: RootState['chats']['selectedChatId'];
  userId: RootState['auth']['id'];
  callId: RootState['call']['dialogId'];
  chatsData: RootState['chats']['chats'];
};

export enum SocialMessageStatsEnum {
  postStats = 'postStats',
  commentStats = 'commentStats',
  postUpd = 'postUpd',
}

export type SocialMessagePayload = {
  comment_count?: number;
  view_count?: number;
  repost_count?: number;
  last_modified?: string;
  reaction_count?: number;
  reactions?: KeyValue<number>;
  c_status?: string;
};

export type SocialMessageType = {
  rObject: string;
  type: SocialMessageStatsEnum;
  payload: SocialMessagePayload;
  rChild?: string;
};

export type handleSocialProps = {
  fullMessage: SocialMessageType;
};

export type handleCallProps = Omit<handleMessageProps, 'selectedChatId'>;

export type handleMessageUtilProps = {
  message: MessageType;
  callId: RootState['call']['dialogId'];
  userId: RootState['auth']['id'];
};
